// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-link-chip[data-v-3bd6007e]{background-color:#f5f7fa!important;border:1px solid #e4e7eb}[data-v-3bd6007e] .row-hide-checkbox .v-data-table__checkbox,[data-v-3bd6007e] .row-hide-checkbox .v-simple-checkbox{visibility:hidden!important;pointer-events:none!important}", ""]);
// Exports
module.exports = exports;
